import { ServiceResult } from '../models';
import {
  CreateRecipeCustomerShareRequest,
  DeleteRecipeCustomerShareRequest,
  RecipeCustomerShare,
  ShareRecipeCustomersRequest,
} from '../models/recipe-customer-share.models';
import ApiService from './api-service';

class RecipeCustomerShareService extends ApiService {
  private static classInstance: RecipeCustomerShareService;

  private constructor() {
    super('RecipeCustomerShare');
  }

  public static getInstance(): RecipeCustomerShareService {
    if (!this.classInstance) {
      this.classInstance = new RecipeCustomerShareService();
    }
    return this.classInstance;
  }

  public getRecipeCustomerShare(recipeCustomerShareId: string): ServiceResult<RecipeCustomerShare> {
    return this.get(`${this.baseUrl}/GetRecipeCustomerShare?recipeCustomerShareId=${recipeCustomerShareId}`);
  }

  public getRecipeCustomerShares(customerId: string): ServiceResult<RecipeCustomerShare[]> {
    return this.get(`${this.baseUrl}/GetRecipeCustomerShares?customerId=${customerId}`);
  }

  public createRecipeCustomerShare(request: CreateRecipeCustomerShareRequest): ServiceResult<RecipeCustomerShare> {
    return this.post(`${this.baseUrl}/CreateRecipeCustomerShare`, request);
  }

  public deleteRecipeCustomerShare(request: DeleteRecipeCustomerShareRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/DeleteRecipeCustomerShare`, request);
  }

  public shareRecipeCustomers(request: ShareRecipeCustomersRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/ShareRecipeCustomers`, request);
  }
}

export default RecipeCustomerShareService;
